<template>
  <section
    v-lenis-scroll
    class="shopmaison-banner-collection"
    :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
  >
    <div class="content_container">
      <h2 class="shopmaison-banner-collection_title">
        {{ shopifyData.sectionTitle }}
      </h2>
      <ul class="list_btnTab staggerEffect">
        <li
          v-for="(button, index) in shopifyData.buttonData"
          :key="index"
          class="btn_tab_item animbtn"
        >
          <a :href="button.link" class="btn_tab_link">{{ button.title }}</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage: this.shopifyData.desktopBannerBg,
    };
  },
  mounted() {
    this.updateBackgroundImage();

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 676) {
        this.backgroundImage = this.shopifyData.mobBannerBg;
      } else {
        this.backgroundImage = this.shopifyData.desktopBannerBg;
      }
    },
  },
};
</script>

<style scoped>
.shopmaison-banner-collection {
  background-size: cover;
  background-position: center;
  position: relative;
}

.content_container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  gap: 87px;
  text-align: center;
}

.shopmaison-banner-collection_title {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}

.list_btnTab.staggerEffect {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
}

.btn_tab_link {
  padding: 7px;
  background-color: #ffffff;
  font-family: 'Adobe Caslon Pro', serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.8px;
  letter-spacing: 0.02em;
  text-decoration: none;
  color: #000000;
  display: block;
  min-width: 114px;
  width: 100%;
  transition: 0.3s;
}

.btn_tab_link:hover {
  background-color: #000;
  color: #fff;
}

@media only screen and (max-width: 768px) {
  .list_btnTab.staggerEffect {
    flex-direction: column;
    gap: 11px;
  }

  .content_container {
    gap: 45px;
  }

  .shopmaison-banner-collection_title {
    padding: 0 41px;
  }

  .btn_tab_link {
    min-width: 145px;
  }
}

@media (max-width: 567px) {
  .shopmaison-banner-collection {
    background-position: right;
  }

  .shopmaison-banner-collection_title {
    font-size: 31px;
    line-height: 44.33px;
  }
}
</style>
